<template>
  <div>
    <svg
      v-if="active && variant === 1"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.52002 5.29004V7.01059"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 4V7.01096"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.48 5.29004V7.01059"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.45497 19.0815C4.56297 19.5702 4.98284 19.9415 5.48333 19.9415H18.5167C19.0172 19.9415 19.4362 19.57 19.548 19.0821C19.7557 18.1752 20 17.5487 20 14.99C20 12.4314 19.7557 11.8049 19.548 10.8979C19.4362 10.4101 19.0172 10.0386 18.5167 10.0386L5.48333 10.0386C4.98284 10.0386 4.56297 10.4099 4.45497 10.8986C4.24663 11.8414 4 12.5191 4 14.99C4 17.4609 4.24663 18.1387 4.45497 19.0815Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="12.0001"
        cy="14.9898"
        r="1.92"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>

    <svg
      v-if="!active && variant === 1"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.52002 5.29004V7.01059"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12 4V7.01096"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M16.48 5.29004V7.01059"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.45497 19.0815C4.56297 19.5702 4.98284 19.9415 5.48333 19.9415H18.5167C19.0172 19.9415 19.4362 19.57 19.548 19.0821C19.7557 18.1752 20 17.5487 20 14.99C20 12.4314 19.7557 11.8049 19.548 10.8979C19.4362 10.4101 19.0172 10.0386 18.5167 10.0386L5.48333 10.0386C4.98284 10.0386 4.56297 10.4099 4.45497 10.8986C4.24663 11.8414 4 12.5191 4 14.99C4 17.4609 4.24663 18.1387 4.45497 19.0815Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <circle
        cx="12.0001"
        cy="14.9898"
        r="1.92"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg
      v-if="variant === 2"
      :width="size"
      :height="size"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.501 14.1793L17.28 14.1693"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M4.45497 16.0429C4.56297 16.5316 4.98284 16.9029 5.48333 16.9029H18.5167C19.0172 16.9029 19.4362 16.5314 19.548 16.0436C19.7557 15.1366 20 14.5101 20 11.9515C20 9.39279 19.7557 8.7663 19.548 7.85936C19.4362 7.3715 19.0172 7 18.5167 7L5.48333 7C4.98284 7 4.56297 7.37134 4.45497 7.86004C4.24663 8.80281 4 9.48055 4 11.9515C4 14.4224 4.24663 15.1001 4.45497 16.0429Z"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <circle
        cx="12.0001"
        cy="11.9516"
        r="1.92"
        stroke="currentColor"
        stroke-width="1.5"
      />
      <path
        d="M6.86084 9.69934L7.63983 9.68933"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>

<script>
export default {
  props: {
    active: Boolean,
    variant: {
      type: Number,
      default: 1
    },
    size: {
      type: [String, Number],
      default: 24
    }
  },
};
</script>

<style></style>
